export default {
    path: '/talentDetail',
    name: 'talentDetail',
    component: () =>
        import(/* webpackChunkName: "talentDetail" */ "@/pages/talentDetail/index.vue"),
    meta: {
        title: '人才库详情'
    },
}